import config from "../../../../../src/env.config";
import { requestMethod } from "../../../../config";
import { fetch } from "../../../../shared/services/api.service";
import { checkApiSuccess } from "../../../../utils";

/**
 * Service functions for handling email rules API operations
 * @author Sarthak Arora
 */

/**
 * Creates a new email rule
 * @author Sarthak Arora
 */
export const addEmailRules = async (payload) => {
  const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/rules/addEmailRules`,
      data: payload,
    },
    response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else {
    throw Error(response.data.message);
  }
};

/**
 * Updates an existing email rule
 * @author Sarthak Arora
 */
export const updateEmailRule = async (payload) => {
  const requestConfig = {
      method: requestMethod.PUT,
      url: `${config.BASE_URL.BASE_API_URL}/rules/updateEmailRules`,
      data: payload,
    },
    response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else {
    throw new Error(response.data.message);
  }
};

/**
 * Fetches all email rules for a workflow
 * @author Sarthak Arora
 */
export const getEmailRules = async (workflowId) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/rules/getEmailRules`,
    params: { workflowId },
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else {
    throw Error(response.data.message);
  }
};

/**
 * Fetches all available email rule actions
 * @author Sarthak Arora
 */
export const getEmailRuleActions = async () => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/rules/getEmailRuleActions`,
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Deletes an email rule
 * @author Sarthak Arora
 */
export const deleteEmailRules = async (ruleId) => {
  let requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/rules/deleteEmailRules`,
    data: { ruleId },
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else {
    throw Error(response.data.message);
  }
};
